export default "__VITE_ASSET__CfxiuE16__"